import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, ManagerDashboardGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import TagManagerPage from 'src/pages/manager/tag-manager';
import TagUploadPage from 'src/pages/uploads/tag-upload';
// The shared Users screen; it scopes itself to the manager's selected organization.
import OwnerAdminUsers from 'src/pages/users/user-management';
import OwnerUsersCreate from 'src/sections/manager/dashboard/admin-users-create';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/one'));
const CampaignsPage = lazy(() => import('src/pages/dashboard/campaigns'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: (
          <ManagerDashboardGuard>
            <IndexPage />
          </ManagerDashboardGuard>
        ),
        index: true,
      },
      {
        path: 'daily-brief',
        element: (
          <ManagerDashboardGuard>
            <IndexPage />
          </ManagerDashboardGuard>
        ),
      },
      {
        path: 'geographical-overview',
        element: (
          <ManagerDashboardGuard>
            <IndexPage />
          </ManagerDashboardGuard>
        ),
      },
      {
        path: 'vote-tracking',
        element: (
          <ManagerDashboardGuard>
            <IndexPage />
          </ManagerDashboardGuard>
        ),
      },
      {
        path: 'users',
        element: <OwnerAdminUsers />,
      },
      {
        path: 'users/:orgId/create',
        element: <OwnerUsersCreate />,
      },
      {
        path: 'tags',
        element: <TagManagerPage />,
      },
      {
        path: 'campaigns',
        element: <CampaignsPage />,
      },
    ],
  },
];
